/**
 * Whether an objective has been handed to the people it concerns. A draft is read as a published
 * objective is but changed by its creator alone, may hold nothing but a title, and counts nowhere;
 * publishing it is final.
 */
export const ObjectiveStatus = {
    PUBLISHED: 'Published',
    DRAFT: 'Draft',
} as const;

export type ObjectiveStatusValue = (typeof ObjectiveStatus)[keyof typeof ObjectiveStatus];
